import { createContext, useContext, useRef, useSyncExternalStore } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const BannerContext = /*#__PURE__*/createContext(null);
const EMPTY_SET = new Set();
const noopSubscribe = __callback => () => {};
export const BannerContextProvider = ({
  children,
  initialPromotionIds = []
}) => {
  const promotionIds = useRef(new Set(initialPromotionIds));
  const subscribers = useRef(new Set());
  const store = useRef({
    get: () => promotionIds.current,
    subscribe: callback => {
      subscribers.current.add(callback);
      return () => subscribers.current.delete(callback);
    },
    register: ids => {
      const next = new Set(promotionIds.current);
      let changed = false;
      for (const id of ids) {
        if (!next.has(id)) {
          next.add(id);
          changed = true;
        }
      }
      if (changed) {
        promotionIds.current = next;
        subscribers.current.forEach(cb => cb());
      }
    }
  });
  return /*#__PURE__*/_jsx(BannerContext.Provider, {
    value: store.current,
    children: children
  });
};
export const useBannerPromotionIds = () => {
  const store = useContext(BannerContext);
  return useSyncExternalStore(store ? store.subscribe : noopSubscribe, store ? store.get : () => EMPTY_SET, () => EMPTY_SET);
};
export const useRegisterBannerPromotionIds = () => {
  var _store$register;
  const store = useContext(BannerContext);
  return (_store$register = store === null || store === void 0 ? void 0 : store.register) !== null && _store$register !== void 0 ? _store$register : null;
};